import { createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import deleteCookie from "../../Utils/Cookies/deleteCookie";
import setCookie from "../../Utils/Cookies/setCookie";
import { login } from "./thunk";

const initialState = {
  isAuthenticated: false,
  loadingLogin: false,
  loadingLogout: false,
  email: null,
  userId: "",
  isAdmin: false,
  isSuperUser: false,
  userName: "",
  authError: false,
  isSuperuser: true,
  permissions: [],
  loadingResetPassword: false,
  loadingChangePassword: false,
  message: [],
  photo: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authError: (state) => {
      storage.removeItem("persist:root");
      deleteCookie("accessToken");
      deleteCookie("refreshToken");
      state.isAuthenticated = false;
      state.loading = false;
      state.email = null;
      state.authError = true;
      state.isSuperuser = true;
    },

    loginSuccess: (state, action) => {
      setCookie("accessToken", action.payload.data?.access, {
        "max-age": 36000000,
      });
      // Comment out or remove the refreshToken handling since it's not provided
      setCookie("refreshToken", action.payload?.data?.refresh, {
        "max-age": 36000000,
      });
      state.permissions = action.payload?.data?.permissions;
      state.isAdmin = action.payload?.data.is_admin;
      state.isSuperUser = action.payload?.data.is_superuser;
      state.isAuthenticated = true;
      state.userName = action.payload?.data?.email;
      state.userId = action.payload?.data?.id;
      state.loadingLogin = false;
      state.authError = false;
    },

    logoutSuccess: (state, action) => {
      storage.removeItem("persist:root");
      deleteCookie("accessToken");
      deleteCookie("refreshToken");
      state.isAuthenticated = false;
      state.loadingLogout = false;
      state.email = null;
      state.userId = null;
      state.authError = false;
      state.isSuperuser = false;
      state.permissions = [];
      state.groups = [];
      state.img = null;
    },
    forgetPassword: (state, action) => {
      state.loadingResetPassword = false;
      state.message = action.payload;
      state.authError = false;
    },
    resetPassword: (state, action) => {
      state.authError = false;
      state.loadingResetPassword = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loadingLogin = true;
      })
      .addCase(login.fulfilled, (state) => {
        state.loadingLogin = false;
      })
      .addCase(login.rejected, (state) => {
        state.loadingLogin = false;
      });
  },
});

const { actions, reducer } = authSlice;
export const {
  authError,
  loginSuccess,
  logoutSuccess,
  forgetPassword,
  resetPassword,
  checkSetupSuccess,
} = actions;
export default reducer;
